(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "react-router", "../constants"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("react-router"), require("../constants"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.reactRouter, global.constants);
    global.useLocationHistory = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _reactRouter, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.useLocationHistory = useLocationHistory;

  function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

  function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

  function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

  function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

  // for resolve problems with removing undefined key values by JSON.parse reviver.
  function JsonSanitize(obj) {
    if (_typeof(obj) === 'object') {
      Object.keys(obj).forEach(function (key) {
        if (_typeof(obj[key]) === 'object') {
          obj[key] = JsonSanitize(obj[key]);
        } else if (obj[key] === 'undef') {
          obj[key] = undefined;
        }
      });
    }

    return obj;
  }

  function JsonParse(raw) {
    try {
      var obj = JsonSanitize(JSON.parse(raw));
      return obj;
    } catch (e) {
      return null;
    }
  } // for save undefined key values.


  function JsonStringify(obj) {
    return JSON.stringify(obj, function (k, v) {
      return v === undefined ? 'undef' : v;
    });
  }

  function useLocationHistory(routerContext) {
    var history = (0, _reactRouter.useHistory)();
    var location = (0, _reactRouter.useLocation)();
    var refLocation = (0, _react.useRef)(location);
    var refDirection = (0, _react.useRef)(null);

    var _useState = (0, _react.useState)(function () {
      var raw = window.sessionStorage.getItem(_constants.LOCATION_STORAGE_NS);

      if (raw && location.key) {
        var json = JsonParse(raw);
        if (json) return json;
      }

      return [_objectSpread({}, location)];
    }),
        _useState2 = _slicedToArray(_useState, 2),
        items = _useState2[0],
        setItems = _useState2[1];

    var findIndex = (0, _react.useCallback)(function (key) {
      if (typeof key === 'function') {
        return items.findIndex(key);
      } else {
        return items.findIndex(function (item) {
          return item.key === key;
        });
      }
    }, [items]);
    var set = (0, _react.useCallback)(function (key, state) {
      var insertPrepend = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return setItems(function (items) {
        var index = items.findIndex(function (item) {
          return item.key === key;
        });

        if (index > -1) {
          items[index] = _objectSpread(_objectSpread({}, items[index]), state);
        } else if (history.action !== _constants.REPLACE) {
          var item = location.key === key ? _objectSpread(_objectSpread({}, location), state) : _objectSpread({
            key: key
          }, state);

          if (insertPrepend) {
            items.unshift(item);
          } else {
            items.push(item);
          }
        }

        return _toConsumableArray(items);
      });
    }, [history, location]);
    var get = (0, _react.useCallback)(function (key) {
      return items.find(function (item) {
        return item.key === key;
      });
    }, [items]);
    var hasPrev = (0, _react.useCallback)(function (key) {
      var index = items.findIndex(function (item) {
        return item.key === key;
      });
      return index < 0 ? null : !!items[index - 1];
    }, [items]);
    var hasNext = (0, _react.useCallback)(function (key) {
      var index = items.findIndex(function (item) {
        return item.key === key;
      });
      return index < 0 ? null : !!items[index + 1];
    }, [items]);
    var getPrev = (0, _react.useCallback)(function (key) {
      var index = items.findIndex(function (item) {
        return item.key === key;
      });
      return index < 0 ? null : items[index - 1] || null;
    }, [items]);
    var getNext = (0, _react.useCallback)(function (key) {
      var index = items.findIndex(function (item) {
        return item.key === key;
      });
      return index < 0 ? null : items[index + 1] || null;
    }, [items]);
    var getPositionOffset = (0, _react.useCallback)(function (key) {
      var currentIndex = items.findIndex(function (item) {
        return item.key === location.key;
      });
      var targetIndex = items.findIndex(function (item) {
        return item.key === key;
      });
      return (targetIndex > -1 ? targetIndex : 0) - currentIndex;
    }, [items, location]);
    (0, _react.useLayoutEffect)(function () {
      var action = history.action;
      var prevLocation = refLocation.current;
      var nextLocation = location;
      setItems(function (items) {
        var changed = false;
        var prevKeyIndex = items.findIndex(function (item) {
          return item.key === prevLocation.key;
        });
        var nextKeyIndex = items.findIndex(function (item) {
          return item.key === nextLocation.key;
        });

        if (prevLocation.pathname === nextLocation.pathname && prevLocation.hash !== nextLocation.hash && (prevLocation.key === undefined ? items[0].hash === prevLocation.hash : true) && (nextLocation.key === undefined ? items[0].hash !== nextLocation.hash : true) && // if target is first page.
        nextLocation.hash) {// hash change
          // do nothing.
        } else if (prevKeyIndex > -1 && action !== _constants.POP) {
          if (action === _constants.PUSH) {
            items.splice(prevKeyIndex + 1, items.length, nextLocation);
            changed = true;
          } else if (action === _constants.REPLACE) {
            items.splice(prevKeyIndex, 1, nextLocation);
            changed = true;
          }
        } else if (action === _constants.POP && nextKeyIndex < 0) {
          if (items.length === prevKeyIndex + 1) {
            items.push(nextLocation);
            changed = true;
          } else {
            items.unshift(nextLocation);
            changed = true;
          }
        }

        return changed ? _toConsumableArray(items) : items;
      });
      refLocation.current = nextLocation;
    }, [history, location]);
    var direction = (0, _react.useMemo)(function () {
      var prevLocation = refLocation.current;
      var prevKeyIndex = items.findIndex(function (item) {
        return item.key === prevLocation.key;
      });
      var nextKeyIndex = items.findIndex(function (item) {
        return item.key === location.key;
      });

      if (prevLocation.pathname === location.pathname && prevLocation.hash !== location.hash && (prevLocation.key === undefined ? items[0].hash === prevLocation.hash : true) && (location.key === undefined ? items[0].hash !== location.hash : true) && // if target is first page.
      location.hash) {
        refDirection.current = _constants.HASHCHANGE;
      } else if (history.action === _constants.PUSH || history.action === _constants.REPLACE) {
        refDirection.current = history.action === _constants.PUSH ? _constants.FORWARD : history._action ? refDirection.current : _constants.REPLACE;
      } else if (history.action === _constants.POP && nextKeyIndex < 0) {
        if (items.length === prevKeyIndex + 1) {
          refDirection.current = _constants.FORWARD;
        } else {
          refDirection.current = _constants.BACKWARD;
        }
      } else if (prevKeyIndex < nextKeyIndex) {
        refDirection.current = _constants.FORWARD;
      } else if (prevKeyIndex > nextKeyIndex) {
        refDirection.current = _constants.BACKWARD;
      }

      return refDirection.current;
    }, [items, history, location]);
    (0, _react.useLayoutEffect)(function () {
      window.sessionStorage.setItem(_constants.LOCATION_STORAGE_NS, JsonStringify(items));
    }, [items]);
    return {
      items: items,
      setItems: setItems,
      direction: direction,
      get: get,
      set: set,
      findIndex: findIndex,
      hasPrev: hasPrev,
      hasNext: hasNext,
      getPrev: getPrev,
      getNext: getNext,
      getPositionOffset: getPositionOffset
    };
  }
});